import { DisplayNames } from 'Roblox';
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-style-guide';

function UserInfo({ profileLink, name, isPremiumUser, displayName }) {
  const nameForDisplay = DisplayNames?.Enabled() ? displayName : name;
  let premiumIcon;
  if (isPremiumUser) {
    premiumIcon = (
      <div className='user-icon-container'>
        <span className='medium-icon icon-premium-medium' />
        <span className='small-icon icon-premium-small' />
      </div>
    );
  }

  return (
    <div className='user-info-container'>
      {premiumIcon}
      <h1 className='user-name-container'>
        <Link url={profileLink}>{nameForDisplay}</Link>
      </h1>
    </div>
  );
}

UserInfo.defaultProps = {
  isPremiumUser: false,
  displayName: null
};

UserInfo.propTypes = {
  profileLink: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isPremiumUser: PropTypes.bool,
  displayName: PropTypes.string
};

export default UserInfo;
